<template>
<div class="related-links">
    <img src="~@/assets/img/dzyndzle_short.svg" alt="" />
    <div class="box-wrapper"></div>
    <div class="related-item">
        <a href="javascript:void(0)" class="arrow-link" title="">
            <div class="img-link">
                <img src="~@/assets/img/biogram/2-photographs.png" alt="" />
                <svg class="box" preserveAspectRatio="none">
                    <rect width="100%" height="100%"/>
                </svg>
            </div>
            <div class="arrow-wrapper">
                <svg viewBox="0 0 113.7 90">
                    <path class="arrow" d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"/>
                    <path class="arrow arrow2" d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"/>
                </svg>
            </div>
            <span>FOTOGRAFIE</span>
        </a>
    </div>
    <div class="related-item">
        <a href="javascript:void(0)" class="arrow-link" title="">
            <div class="img-link" style="align-self:flex-start; margin-left: 6rem;">
                <img src="~@/assets/img/list_einstein_1.png" alt="" />
                <svg class="box" preserveAspectRatio="none">
                    <rect width="100%" height="100%"/>
                </svg>
            </div>
            <div class="arrow-wrapper">
                <svg viewBox="0 0 113.7 90">
                    <path class="arrow" d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"/>
                    <path class="arrow arrow2" d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"/>
                </svg>
            </div>
            <span style="padding-left: 10rem;">DOKUMENTY</span>
        </a>
    </div>
    <div class="related-item inverse">
        <a href="javascript:void(0)" class="arrow-link" title="">
            <div class="img-link" style="align-self:flex-end; margin-right: 9rem;">
                <img src="~@/assets/img/biogram/3-pubs.png" alt="" />
                <svg class="box" preserveAspectRatio="none">
                    <rect width="100%" height="100%"/>
                </svg>
            </div>
            <div class="arrow-wrapper">
                <svg viewBox="0 0 113.7 90">
                    <path class="arrow" d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"/>
                    <path class="arrow arrow2" d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"/>
                </svg>
            </div>
            <span>PUBLIKACJE</span>
        </a>
    </div>
</div>
</template>
<script>

export default {
  name: 'PageRelated',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Page/PageRelated.vue